// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".login[data-v-944133b4]{display:flex;height:100%;align-items:center;justify-content:center}.v-form[data-v-944133b4]{width:28rem}h1[data-v-944133b4]{margin-bottom:100px}", ""]);
// Exports
module.exports = exports;
